module.exports = __webpack_public_path__ + "static/media/030-Rose & Crown.7796a051.png";